<ng-container *ngIf="singleBetPick">
    <div
        class="betslip-digital-bet-pick-column-1 {{ pickClass }}"
        [ngClass]="{ 'betslip-single-bet-price-boosted-pick': isPickOddsPriceBoosted }"
        (click)="clickInfo.emit($event)">
        <ng-container
            *ngTemplateOutlet="
                pickTemplate;
                context: {
                    pick: pick,
                    messages: messages,
                    betslipType: betslipType,
                    showEachWay: singleBetPick.isEachWay,
                    hideLineSwitcher: isLinear,
                    marketLogoTooltipAppendTo: marketSubtypeLogoTooltipBoundaries,
                    marketLogoTooltipBoundaries: marketSubtypeLogoTooltipBoundaries,
                    marketLogoTooltipPlacement: 'bottom-start',
                    marketLogoTrackingLocation: 'betslip',
                    wrapMarketLogoTitle: isLinear,
                }
            " />
        <bs-digital-pick-odds [pick$]="pickChange$" [oddsDisplayFormat]="oddsDisplayFormat" />
        <ng-container *ngIf="!isLinear; else linearSummary">
            <div class="betslip-digital-single-bet-pick-stake-container" *ngIf="hasStakeInput">
                <div class="betslip-digital-single-bet-pick-eachway-stake" *ngIf="isMultiplierVisible">{{ multiplierValue }}</div>
                <bs-digital-single-bet-pick-stake
                    [pickId]="pick.id"
                    [stake]="singleBetPick.stake"
                    [isDisabled]="isStakeInputDisabled"
                    [freeBetToken]="freeBetToken$ | async"
                    (stakeChange)="onStakeChange($event)" />
            </div>
            <span class="betslip-digital-single-bet-pick-possible-winnings" *ngIf="hasStakeInput && singleBetPick.stake && singleBetPick.stake > 0">
                {{ isTaxationApplied ? messages.common.PossibleWinningsNet : messages.common.ToReturn }}
                <span class="winning-value">{{ possibleWinnings$ | async | bsCurrency: true }}</span>
                <bs-digital-token-summary-container *msShowInEpcot="{ showInEpcot: false, module: module }" [tokenContext]="tokenContext" />
            </span>
            <bs-reward-tokens-selector-container
                class="betslip-digital-single-bet-pick-tokens-container"
                *ngIf="hasStakeInput"
                [tokenContext]="tokenContext" />
        </ng-container>
    </div>
</ng-container>

<ng-template #linearSummary>
    @if (hasStakeInput) {
        <div class="linear-single-bet-pick-summary-container">
            <div class="linear-single-bet-pick-summary" (click)="preventClick($event)">
                <bs-linear-single-bet-pick-summary [pickId]="pick.id" />
            </div>
            @if (!isPickOddsStateLocked) {
                <div class="linear-single-bet-pick-rewards">
                    <bs-digital-token-summary-container *msShowInEpcot="{ showInEpcot: false, module: module }" [tokenContext]="tokenContext" />
                    <bs-reward-tokens-selector-container [tokenContext]="tokenContext" />
                </div>
            }
        </div>
    }
</ng-template>
